import { useEffectOnce } from '@custom-react-hooks/use-effect-once';
import { Helmet } from 'react-helmet';
import { ENV_VARS } from '@/clients/util/env';

interface FacebookPixel {
  (command: 'init', pixelId: string): void;
  (command: 'track', event: string, parameters?: Record<string, unknown>): void;
  (command: 'trackCustom', event: string, parameters?: Record<string, unknown>): void;
  push: (...args: unknown[]) => void;
}

declare global {
  interface Window {
    fbq?: FacebookPixel;
  }
}

export function FacebookPixel({ authedUser }: { authedUser?: boolean }) {
  const enabled = ENV_VARS.PROD;
  const fbPixelId = ENV_VARS.VITE_FACEBOOK_PIXEL_ID;

  useEffectOnce(() => {
    const initPixel = () => {
      if (window.fbq && enabled) {
        window.fbq('init', fbPixelId);
        window.fbq('track', 'PageView');
        const registrationTracked = localStorage.getItem('fb-pixel-tracked');
        if (authedUser && !registrationTracked) {
          window.fbq('track', 'CompleteRegistration');
          localStorage.setItem('fb-pixel-tracked', 'true');
        }
      } else {
        setTimeout(initPixel, 100);
      }
    };
    initPixel();
  });
  return (
    <>
      {enabled && (
        <Helmet>
          <script>
            {`
            !function(f,b,e,v,n,t,s) {if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)}; if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0'; n.queue=[];t=b.createElement(e);t.async=!0; t.src=v;s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s)}(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js');
            `}
          </script>
        </Helmet>
      )}
      {enabled && (
        <noscript>
          <img
            alt=""
            height="1"
            width="1"
            style={{ display: 'none' }}
            src={`https://www.facebook.com/tr?id=${fbPixelId}&ev=PageView&noscript=1`}
          />
        </noscript>
      )}
    </>
  );
}
